import './App.css';

/**
 * Renders a back button component.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {Function} props.handleBack - The function to be called when the button is clicked.
 * @returns {JSX.Element} A button element with a "Back" label for screen readers.
 */
function BackButton(props) {

  return (
    <>
      <button className="back-button" onClick={props.handleBack}><span className="sr-only">Back</span></button>
    </>
  );
}

export default BackButton;